import { makeStyles, useTheme, Skeleton } from '@paintscout/ui'
import classNames from 'classnames'
import times from 'lodash/times'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: theme.spacing(1, 2)
  },
  flexItem: {
    flex: '0 0 20%',
    maxWidth: '20%',
    boxSizing: 'border-box',
    padding: theme.spacing(1)
  },
  rightAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(-1)
  },
  daySkeleton: {
    background: theme.paintscout.palette.brand?.Neutral?.P96
  },
  darkGrey: {
    background: theme.paintscout.palette.brand?.Neutral?.P85
  },
  daySkeletonDate: {
    width: '16px',
    height: '16px',
    background: theme.paintscout.palette.brand?.Neutral?.P85,
    borderRadius: theme.borderRadius.md,
    position: 'absolute',
    top: 16,
    right: 16
  },
  eventBar: {
    position: 'absolute',
    left: 16,
    right: 16,
    height: 14,
    borderRadius: theme.borderRadius.md,
    display: 'flex',
    alignItems: 'center'
  },
  eventBadge: {
    marginLeft: 'auto',
    width: 16,
    height: 14,
    borderRadius: theme.borderRadius.md
  }
}))

export default function CRMPromptCalendarShim() {
  const classes = useStyles()
  const theme = useTheme()

  const ColumnHeaderSkeleton = () => (
    <div className={classNames(classes.flexItem, classes.rightAlign)}>
      <Skeleton variant="rect" width="32px" height={16} className={classes.darkGrey} />
    </div>
  )

  const DaySkeleton = ({ mockEvents = [] }: { mockEvents: { light: string; dark: string }[] }) => (
    <div className={classes.flexItem} style={{ position: 'relative' }}>
      <Skeleton variant="rect" width="100%" height={130} className={classes.daySkeleton} />
      <div className={classes.daySkeletonDate} />
      {mockEvents.map((color, idx) => (
        <div
          key={idx}
          className={classes.eventBar}
          style={{
            top: 40 + idx * 18,
            background: color.light
          }}
        >
          <div
            className={classes.eventBadge}
            style={{
              background: color.dark
            }}
          />
        </div>
      ))}
    </div>
  )

  const mockEvents = [
    [],
    [],
    [],
    [],
    [],
    [],
    [
      {
        light: theme.paintscout.palette.secondary[290].C90,
        dark: theme.paintscout.palette.secondary[290].C70
      },
      {
        light: theme.paintscout.palette.secondary[20].C90,
        dark: theme.paintscout.palette.secondary[20].C70
      },
      {
        light: theme.paintscout.palette.brand.Neutral.P90,
        dark: theme.paintscout.palette.brand.Neutral.P70
      }
    ],
    [],
    [
      {
        light: theme.paintscout.palette.brand.Neutral.P80,
        dark: theme.paintscout.palette.brand.Neutral.P50
      },
      {
        light: theme.paintscout.palette.secondary[290].C90,
        dark: theme.paintscout.palette.secondary[290].C70
      }
    ],
    [],
    [],
    [],
    [
      {
        light: theme.paintscout.palette.secondary[230].C90,
        dark: theme.paintscout.palette.secondary[230].C70
      },
      {
        light: theme.paintscout.palette.brand.Neutral.P80,
        dark: theme.paintscout.palette.brand.Neutral.P50
      },
      {
        light: theme.paintscout.palette.secondary[140].C90,
        dark: theme.paintscout.palette.secondary[140].C70
      }
    ],
    [],
    [
      {
        light: theme.paintscout.palette.secondary[230].C90,
        dark: theme.paintscout.palette.secondary[230].C70
      },
      {
        light: theme.paintscout.palette.secondary[140].C90,
        dark: theme.paintscout.palette.secondary[140].C70
      }
    ],
    [],
    [
      {
        light: theme.paintscout.palette.secondary[80].C90,
        dark: theme.paintscout.palette.secondary[80].C70
      }
    ],
    [],
    [
      {
        light: theme.paintscout.palette.secondary[80].C90,
        dark: theme.paintscout.palette.secondary[80].C70
      }
    ]
  ]

  return (
    <div className={classes.flexContainer}>
      {times(5, (i) => (
        <ColumnHeaderSkeleton key={i} />
      ))}
      {times(25, (i) => (
        <DaySkeleton key={i} mockEvents={mockEvents[i % mockEvents.length]} />
      ))}
    </div>
  )
}

CRMPromptCalendarShim.title = (_: Date) => {
  return ''
}

CRMPromptCalendarShim.navigate = (date: Date, _: string) => {
  return date
}
